import { FC, useCallback, useState } from 'react'
import { CardlessEMIType } from '../../data/models/CardlessEMI'
import { useStores } from '../../data/store'
import { isIFrame } from '../../utils'
import { EMI, windowConfig } from '../../utils/constants'
import { Dropdown } from './DropDown'

const CarldlessEMI: FC<{
  show: boolean
  onClose: () => void
  setShowPaymentProcessModal: (value: boolean) => void
}> = ({ show, onClose, setShowPaymentProcessModal }) => {
  const { cardLessEMIList, getCardLessEMIBank, addPaymentMethod, uniqueWindowId } = useStores((root) => ({
    uniqueWindowId: root.config.uniqueWindowId,
    cardLessEMIList: root.getCardLessEMIList(),
    getCardLessEMIBank: root.getCardLessEMIBank,
    addPaymentMethod: root.transaction.addPaymentMethod,
  }))

  const { REACT_APP_URL = '', REACT_APP_ENDPOINT = '' } = process.env

  const [selectedItem, setSelectedItem] = useState('')

  const loadProcessingScreen = useCallback(() => {
    const loaderUrl = REACT_APP_ENDPOINT
      ? `${REACT_APP_URL}/${REACT_APP_ENDPOINT}/loader.html`
      : `${REACT_APP_URL}/loader.html`
    if (!isIFrame()) {
      window.currentChild = window
    } else {
      window.currentChild = window.open(loaderUrl, `jiopayWindow-${uniqueWindowId}`, windowConfig)
      window.currentChild?.focus()
    }
    setShowPaymentProcessModal(true)
  }, [REACT_APP_ENDPOINT, REACT_APP_URL, setShowPaymentProcessModal, uniqueWindowId])

  const setSelection = (value: string) => {
    const item = cardLessEMIList.find((item: any) => item?.text === value)?.id || ''
    setSelectedItem(item ?? '')
    onClose()
    const emi: CardlessEMIType = getCardLessEMIBank(item)
    addPaymentMethod(emi)
    loadProcessingScreen()
  }

  const getSelectedvalue = () => {
    const selectedBank = cardLessEMIList?.find((item: any) => item.id === selectedItem)
    return selectedBank?.text ?? ''
  }

  console.log('CarldlessEMI setShowPaymentProcessModal', setShowPaymentProcessModal)

  if (!show) {
    return null
  }
  return (
    <>
      <Dropdown
        data={cardLessEMIList}
        type={EMI.CARDLESS}
        label={'Select Issuer Bank'}
        placeHolder={'Select Issuer Bank'}
        showLabel={false}
        onChange={setSelection}
        value={getSelectedvalue()}
        isModalSizeFixed={true}
        newSheet={true}
        setSelectedItem={setSelectedItem}
        onClose={onClose}
      />
    </>
  )
}

export { CarldlessEMI }
